import React, { useState } from 'react'
import { useStore } from 'store'
import { styled } from '@material-ui/core/styles'

import { signOut } from 'providers/AuthProvider'

import {
  Popover,
  Avatar,
  Typography,
  Card,
  CardActions,
  CardContent,
} from '@material-ui/core'
import { Button } from 'components'

const SignOutButton = (props) => (
  <Button variant="contained" onClick={signOut} {...props}>
    Uitloggen
  </Button>
)

const Container = styled('div')(({ theme }) => ({
  display: 'inline-block',
  verticalAlign: 'middle',
  marginLeft: theme.spacing(1),
}))

const StyledAvatar = styled(Avatar)({
  height: 28,
  width: 28,
  cursor: 'pointer',
})

const PopoverContent = ({ fullName, email }) => (
  <Card>
    <CardContent>
      {fullName && <Typography>{fullName}</Typography>}
      <Typography>{email}</Typography>
    </CardContent>
    <CardActions>
      <SignOutButton />
    </CardActions>
  </Card>
)

const ProfileMenu = () => {
  const [{ auth, airbnbData }] = useStore()
  const [anchorEl, setAnchorEl] = useState(null)

  const { user, isAuthenticated, loading } = auth

  if (loading || !isAuthenticated) {
    return null
  }

  const email = auth?.user?.email
  const fullName = airbnbData?.contact?.fullName

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Container>
      <StyledAvatar
        onClick={handleClick}
        alt={user.displayName}
        src={user.photoURL}
        data-testid="profileMenu"
      />
      <Popover
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <PopoverContent fullName={fullName} email={email} />
      </Popover>
    </Container>
  )
}

export default ProfileMenu
